// CONSTANTS
/**
 * Example of JSON in local storage:
 * [BANNER_BOTTOM_STATUS.OBJECT_KEY]: "{
    status: OK || KO,
    expiration: 3627836,
  }"
 */
export const BANNER_BOTTOM_PERSONALIZATION_STATUS = Object.freeze({
  OBJECT_KEY: 'bannerBottomPersonalizationStatus',
  OK: {
    NAME: 'OK',
    EXPIRATION_DAYS: 15,
  },
  KO: {
    NAME: 'KO',
    EXPIRATION_DAYS: 15,
  },
});
export const BANNER_BOTTOM_CTA_STATUS = Object.freeze({
  OBJECT_KEY: 'bannerBottomCTAStatus',
  KO: {
    NAME: 'KO',
    EXPIRATION_DAYS: 15,
  },
});
export const BANNER_BOTTOM_WPN_STATUS = Object.freeze({
  OBJECT_KEY: 'bannerBottomWPNStatus',
  OK: {
    NAME: 'OK',
    EXPIRATION_DAYS: 1,
  },
  KO: {
    NAME: 'KO',
    EXPIRATION_DAYS: 1,
  },
});

/**
 * Example of JSON in local storage:
 * WPN stands for Web Push Notifications
 * [WPN_STATUS.OBJECT_KEY]: "{
    status: OK || KO || KO_SOFT || UNSUBSCRIBED,
    expiration: 3627836,
  }"
  NOTE: This stores the status of the user interaction with the first pop-up
 */
export const WPN_STATUS = Object.freeze({
  OBJECT_KEY: 'WPNStatus',
  OK: {
    NAME: 'OK',
    EXPIRATION_DAYS: 15,
  },
  KO: {
    NAME: 'KO',
    EXPIRATION_DAYS: 15,
  },
  KO_SOFT: {
    NAME: 'KO_SOFT',
    EXPIRATION_DAYS: 15,
  },
  UNSUBSCRIBED: {
    NAME: 'UNSUBSCRIBED',
    EXPIRATION_DAYS: 15,
  },
});

/**
 * Example of JSON in local storage:
 * [WPN_DAILY_SESSION.OBJECT_KEY]: "{
    expiration: 3627836,
  }"
 */
export const WPN_DAILY_SESSION = Object.freeze({
  OBJECT_KEY: 'WPNDaily',
  EXPIRATION_DAYS: 1,
});

//  NOTE: This stores the status of the actual user subscription to the WPN
export const WPN_SUBSCRIPTION = Object.freeze({
  OBJECT_KEY: 'WPNSubscription',
  SUBSCRIBED: {
    NAME: 'iscritto',
  },
  UNSUBSCRIBED: {
    NAME: 'disiscritto',
  },
});

// UTILS
/**
 * @param {Number} days
 * @returns {Timestamp} in milliseconds
 */
const daysToTimestamp = (days = 1) => days * 24 * 60 * 60 * 1000;

/**
 * @param {String} key to get from local storage
 * @returns {Object || Any}
 */
export const getLocalStorage = (key) => {
  try {
    return JSON.parse(localStorage.getItem(key));
  } catch (error) {
    return localStorage.getItem(key);
  }
};

export const isSetOnLocalStorage = (key) => Boolean(getLocalStorage(key));

/**
 * @param {String} key to set on local storage
 * @param {Object} value to set on local storage
 */
export const setLocalStorage = (key, value) => {
  if (typeof value === 'object') {
    localStorage.setItem(key, JSON.stringify(value));
  } else {
    localStorage.setItem(key, value);
  }
};

/**
 * @param {String} key to remnove from local storage
 */
export const removeLocalStorage = (key) => {
  localStorage.removeItem(key);
};

const buildExpirationTimestamp = (daysBeforeExpiration) => Date.now() + daysToTimestamp(daysBeforeExpiration);

const buildLocalStorageObject = (statusName, daysBeforeExpiration) => {
  const pushObject = {};
  pushObject.status = statusName;
  if (daysBeforeExpiration) {
    pushObject.expiration = buildExpirationTimestamp(daysBeforeExpiration);
  }
  return pushObject;
};

export const setStatusOnLocalStorage = ({ key, name, expirationDays }) => {
  const pushObject = buildLocalStorageObject(name, expirationDays);
  setLocalStorage(key, pushObject);
};
export const setDailySessionOnLocalStorage = (key, expirationDays) => {
  setLocalStorage(key, {
    expiration: buildExpirationTimestamp(expirationDays),
  });
};
export const checkExpirationOnLocalStorage = (statusConfig, dailySessionConfig) => {
  if (Date.now() > getLocalStorage(statusConfig.OBJECT_KEY)?.expiration) {
    removeLocalStorage(statusConfig.OBJECT_KEY);
  }
  if (Date.now() > getLocalStorage(dailySessionConfig.OBJECT_KEY)?.expiration) {
    removeLocalStorage(dailySessionConfig.OBJECT_KEY);
  }
};
